// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1255":"3578473b","2777":"c6dbdb15","3855":"1b77ff46","5580":"2b49e55c","9042":"21fa06c3"}[chunkId] + ".chunk.css";
};